import { InstantBookSettings } from "../util/type_defs";
import { get_reserve_settings } from "./instantBook_scripts";

export function display_pre_checkout() {
    const form:HTMLFormElement = document.getElementById("instantBookForm") as HTMLFormElement;
    const spot_id:number = parseInt(this.getAttribute("spot_id"));
    const settings:InstantBookSettings = get_reserve_settings(form);

    window.spotId = spot_id;

    const dates_str:string = `${settings.dates[0].toLocaleDateString()} - ${settings.dates[1].toLocaleDateString()}`;

    document.getElementById("checkoutForm").setAttribute("spotId", spot_id.toString());

    const spot_el:HTMLElement = document.querySelector(`[spot_id='${spot_id}']`);
    const spot_img_url:string = $(spot_el).find("[spot_img]").css("background-image");

    const n_nights:number = (settings.dates[1].getTime() - settings.dates[0].getTime()) / (1000 * 3600 * 24)
    const rate:number = parseFloat(spot_el.querySelector("[price]").getAttribute("rate"));
    const subTotal:number = rate * n_nights;

    let guestsStr_components:string[] = [
        `${window.guests.adults} adult` + (window.guests.adults > 1? "s": "")
    ];
    if (window.guests.children > 0) {
        guestsStr_components.push(`${window.guests.children} child` + (window.guests.children > 1? "ren": ""));
    };
    if (window.guests.infants > 0) {
        guestsStr_components.push(`${window.guests.infants} infant` + (window.guests.infants > 1? "s": ""));
    }
    if (window.guests.pets > 0) {
        guestsStr_components.push(`${window.guests.pets} pet` + (window.guests.pets > 1? "s": ""));
    }
    const guestsStr:string = guestsStr_components.join(",");

    const offcanvas:HTMLElement = document.getElementById("reserveOffcanvas")
    $(offcanvas).find("#reserveOffcanvasImg").css("background-image", spot_img_url);
    offcanvas.querySelector("#reserveOffcanvase_spotName").innerHTML = spot_el.querySelector("[spot_name]").innerHTML;
    $(offcanvas).find("[reserveOffcanvas_rate]").html(rate.toString());
    offcanvas.querySelector("#reserveOffcanvas_numNight").innerHTML = n_nights.toString();
    offcanvas.querySelector("#reserveOffcanvas_dates").innerHTML = dates_str;
    offcanvas.querySelector("#subtotal").innerHTML = `$${subTotal.toString()}`;
    offcanvas.querySelector("#reserveOffcanvas_guests").innerHTML = guestsStr;
};

export function ConfirmAndPayModalDisplay(spotId: string) {
    const form = document.getElementById("instantBookForm") as HTMLFormElement;
    const settings = get_reserve_settings(form);

    window.spotId = parseInt(spotId);

    document.getElementById("checkoutForm").setAttribute("spotId", spotId.toString());

    const spot_el = document.querySelector(`[spot_id='${spotId}']`);
    const spot_img_url = $(spot_el).find("[spot_img]").css("background-image");
    console.log(spot_img_url);
    const n_nights = Math.round((settings.dates[1].getTime() - settings.dates[0].getTime()) / (1000 * 3600 * 24));
    const rate = parseFloat(spot_el.querySelector("[price]").getAttribute("rate"));
    const subTotal = rate * n_nights;

    let guestsStr_components = [`${window.guests.adults} adult` + (window.guests.adults > 1 ? "s" : "")];
    if (window.guests.children > 0) guestsStr_components.push(`${window.guests.children} child` + (window.guests.children > 1 ? "ren" : ""));
    if (window.guests.infants > 0) guestsStr_components.push(`${window.guests.infants} infant` + (window.guests.infants > 1 ? "s" : ""));
    if (window.guests.pets > 0) guestsStr_components.push(`${window.guests.pets} pet` + (window.guests.pets > 1 ? "s" : ""));
    const guestsStr = guestsStr_components.join(",");

    const dates_str = `${settings.dates[0].toLocaleDateString()} - ${settings.dates[1].toLocaleDateString()}`;

    if (spot_img_url !== undefined) {
        $("#confirmandpaymodalImg").css("background-image", spot_img_url);
    } else {
        $("#confirmandpaymodalImg").css("height",0);
    }
    $("#confirmandpaymodal_spotName").html(spot_el.querySelector("[spot_name]").innerHTML);
    $("[confirmandpaymodal_rate]").html(rate.toString());
    $("#confirmandpaymodal_numNight").html(n_nights.toString());
    $("#confirmandpaymodal_dates").html(dates_str);
    $("#confirmandpaymodal_guests").html(guestsStr);
    $("#subtotal").html(`$${subTotal.toFixed(2)}`);
}